export function ProofOfPlayReportsV2Service(ApiRestangular, StorageService) {
  'ngInject';
  ApiRestangular.setBaseUrl(process.env.__backendUrl__);
  let resourceUrl = `api/proof_of_play/v2/reports`;
  let service = ApiRestangular.service(resourceUrl);
  
  service.isCompleted = function(report) {
    return report.state == 'COMPLETED';
  }

  service.downloadUrl = function(report) {
    if (service.isCompleted(report)) {
      let url = report.one('download').getRestangularUrl();
      const idToken = StorageService.get('idToken');  // TODO: use SessionsService.
      url += '?JWT=' + idToken; // why don't we use cookies??
      return url;
    }
  }

  return service;
}
